<template>
</template>

<script>
export default {
  middleware: [
    'isAuthorized',
    'allowNonMember',
    'hasBeenInducted',
    'initializer'
  ]
}
</script>

<style lang="scss" scoped>

</style>
